import "/Assets/Js/Types%5EIndex.compiled.js?v=a1b25ba8f32e66d551653b5c64742f18d78a5fa6a1cff8666f1f3ec1f6d038ee";

document.addEventListeners(['DOMContentLoaded'], function () {
    // Cast event to KeyboardEvent or type parameter as Event
    function handleKeyPress(event: Event): void {
        const keyEvent = event as KeyboardEvent;
        if (keyEvent.key === "Enter") {
            Update();
        }
    }

    function togglePassword(): void {
        const input = document.getElementById("authkeyInput") as HTMLInputElement | null;
        const checkbox = document.getElementById("showPassword") as HTMLInputElement | null;
        const label = document.getElementById("showPasswordText") as HTMLLabelElement | null;

        if (input && checkbox && label) {
            if (checkbox.checked) {
                input.type = "text";
                label.textContent = "Hide Authkey";
            } else {
                input.type = "password";
                label.textContent = "Show Authkey";
            }
        }
    }

    function Update(): void {
        const input = document.getElementById('authkeyInput') as HTMLInputElement | null;
        if (!input) return;

        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('AuthKey', input.value);
        window.location.href = currentUrl.toString();
    }

    // Query elements once and verify none are null
    const authInput = document.getElementById("authkeyInput");
    const showPasswordBtn = document.getElementById("showPassword");
    const submitBtn = document.getElementById("authkeysubmit");

    if (authInput && showPasswordBtn && submitBtn) {
        authInput.addEventListeners(["keydown"], handleKeyPress);
        showPasswordBtn.addEventListeners(["click"], togglePassword);
        submitBtn.addEventListeners(["click"], Update);
    }
});